import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Customers() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/customers").then((r) => setItems(r.data)); }, []);
  return (
    <div data-testid="admin-customers">
      <h1 className="mb-6 font-display text-3xl font-bold text-navy">Customers</h1>
      <div className="overflow-x-auto rounded-2xl border border-border bg-white card-shadow">
        <table className="w-full text-left text-sm">
          <thead className="border-b border-border bg-cream text-xs uppercase text-muted-foreground"><tr><th className="p-3">Name</th><th className="p-3">Email</th><th className="p-3">Orders</th></tr></thead>
          <tbody>{items.map((u) => (<tr key={u.id} className="border-b border-border last:border-0"><td className="p-3 font-medium text-navy">{u.name}</td><td className="p-3 text-navy/70">{u.email}</td><td className="p-3 text-navy">{u.order_count}</td></tr>))}</tbody>
        </table>
      </div>
    </div>
  );
}
